import React, { useEffect, useRef, useState } from "react";
import placeholder from "../../assets/images/placeholder.webp";
import { Link } from "react-router-dom";
import styles from "./LazyImage.module.css";
import { getFlagTextColor } from "../../utility/getFlagTextColor";

const LazyImage = ({ src, alt, urlKey, urlState, flagText }) => {
  const imgRef = useRef();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // Stop observing once the image is in view
        }
      },
      { threshold: 0.1 }
    );

    if (imgRef.current) {
      observer.observe(imgRef.current);
    }

    return () => {
      if (imgRef.current) {
        observer.unobserve(imgRef.current);
      }
    };
  }, []);

  return (
    <figure ref={imgRef}>
      {flagText && flagText?.toLowerCase() !== "na" ? (
        <div
          className={styles.ribbon}
          style={{
            borderImage: `conic-gradient(${getFlagTextColor(
              flagText
            )} 0 0) fill 0`,
          }}
        >
          {flagText}
        </div>
      ) : null}
      <Link state={{ url: urlState }} to={`/product/${urlKey}.html`}>
        <img
          src={isVisible ? src : placeholder}
          alt={isVisible ? alt : "placeholder"}
        />
      </Link>
    </figure>
  );
};

export default LazyImage;
